import React from 'react'
import { observer } from 'mobx-react'
import { IonContent } from '@ionic/react'
import { range } from '@dt/fe-utils/dist/lodash'
import { doComboMobx, doProductMobx, restaurantConfig } from 'restaurant'
import { ProductImage } from 'components'
import CashierController from 'controllers/cashierController'

interface IProps {
}

const Cart: React.FC<IProps> = ({ }) => {
  const { doCombo, productGroups } = doComboMobx

  const handleClick = (product) => {
    doProductMobx.pick({ cartItem: product, groupNo: product.groupNo, initAdd: true, isCombo: true, salesCnt: product.cnt })
    CashierController.openProductDetail(product, {
      type: 'combo',
      scaleNo: product.scaleNo,
      targetNo: product.groupNo,
    })
  }

  return (
    <div className='combo-cart-panel' id='comboCartPanel'>
      <div className='title'>{i18n.t('newCart.myChoice')}</div>
      <IonContent id='comboFooterCartContent' scrollY={false} scrollX>
        <div className='group-panel'>
          {
            productGroups.map((group, idx) => {
              return (
                <div className='group-item' id={`CFCG_${group.no}`} key={group.no}>
                  {idx !== 0 && <div className='split-item'><i className='iconfont icon-add'></i></div>}
                  {
                    range(group.selectMin).map(index => {
                      const productGroup = doCombo.productGroups?.find(item => item.no === group.no)
                      const product = productGroup?.productGroupDetails[index]
                      return (
                        <div className='product-item' key={index} data-cypid={`comboProductItem_${product?.productNo}`} onClick={() => product && handleClick(product)}>
                          {product && <ProductImage color={!product.pic && restaurantConfig.displayMode === 'waterfall' ? product.productNo : ''} width={40} imgSrc={product.pic} />}
                        </div>
                      )
                    })
                  }
                </div>
              )
            })
          }
        </div>
      </IonContent>
    </div>
  )
}

export default observer(Cart)
